import React from "react";
import PropTypes from "prop-types";
import {
  triggerNavigation,
  ingestData,
  isMobile,
} from "../../bridges/BridgeServices";
import "./ctaLabel.scss";
import { EVENTS } from "../../utils/constants";

const CTALabel = props => {
  const {
    ctaTitle = "",
    ctaSubtitle = "",
    ctaAppDeeplink = "",
    ctaWebLink = "",
    faqTitle = "",
    className = "",
  } = props;

  const handleClick = () => {
    triggerNavigation({
      deepLink: ctaAppDeeplink,
      webURL: ctaWebLink,
    });
    ingestData({
      name: EVENTS.FLOATING_CTA_CLICKED,
      data: {
        faqTitle,
        floatingCtaTitle: ctaTitle,
      },
    });
  };

  return (
    <div className={`cta-wrapper ${className}`}>
      {!isMobile() && (
        <p className="cta-desc">{ctaSubtitle}</p>
      )}
      <button className="cta" onClick={handleClick}>
        {ctaTitle}
      </button>
    </div>
  );
};

CTALabel.propTypes = {
  ctaTitle: PropTypes.string,
  ctaSubtitle: PropTypes.string,
  ctaAppDeeplink: PropTypes.string,
  ctaWebLink: PropTypes.string,
  ctaType: PropTypes.string,
  faqTitle: PropTypes.string,
  className: PropTypes.string,
};

export default CTALabel;
